import React, { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Games from "./screens/nav/games";
import NewsArticle from "./screens/nav/news/news-article";
import SignUp from "./screens/auth/signup";
import Login from "./screens/auth/login";
import NotFoundPage from "./screens/NotFound";
import Profile from "./screens/nav/dashboard/profile";
import ForgetPassword from "./screens/auth/forget-password";
import VerifyOTP from "./screens/auth/verify-otp";
import ResetPassword from "./screens/auth/reset-password";
import PolicyPage from "./screens/Policy/policy";
import TermsPage from "./screens/Policy/terms";
// import CreateFixture from "./screens/nav/fixture"
import News from "./screens/nav/news";
import Home from "./screens/nav/home";
import Tournaments from "./screens/nav/tournaments";
import CreateTournament from "./screens/nav/tournaments/create-tournament";
import TournamentDetails from "./screens/nav/tournaments/tournament-details";
import TournamentBracket from "./screens/nav/tournaments/bracket";
import { useAuth } from "./common/store/authStore";
import { fetchUserCountry } from "./common/services/geo";
import Dashboard from "./screens/nav/dashboard";
import { TournamentProvider } from "./common/store/tournamentStore";
// import Leaderboard from "./screens/nav/leaderboard";
// import OurStory from "./pages/about/OurStory";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: React.FC = () => {
  const { setUserCountry, userCountry } = useAuth();

  useEffect(() => {
    if (!userCountry) {
      fetchUserCountry()
        .then(country => {
          if (country) {
            setUserCountry(country);
          }
        })
        .catch(error => {
          console.error("Error fetching user country:", error);
        });
    }
  }, [userCountry, setUserCountry]);

  return (
    <>
      <TournamentProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/games" element={<Games />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsArticle />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/verify-otp" element={<VerifyOTP />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create-tournament" element={<CreateTournament />} />
            <Route path="/tournaments/:tournamentURL" element={<TournamentDetails />} />
            <Route path="/fixtures/:tournamentURL" element={<TournamentBracket />} />
            {/* <Route path="/create-bracket" element={<CreateFixture />} /> */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/policy" element={<PolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<NotFoundPage />} />
            {/* <Route path="/leaderboard" element={<Leaderboard/>} /> */}
          </Routes>
        </Router>
      </TournamentProvider>
    </>
  );
};

export default App;
